import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/ingreso/getIngresos.php';

export default function getIngresos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}